const e = {
  small: {
    circleSize: "32px",
    iconSize: "large"
  },
  medium: {
    circleSize: "40px",
    iconSize: "large"
  },
  large: {
    circleSize: "48px",
    iconSize: "large"
  },
  xlarge: {
    circleSize: "60px",
    iconSize: "xlarge"
  }
};
export {
  e as sizeMap
};
